import React from "react";
import {BaseComponent} from "react-vextensions";
import {Observer} from "web-vcore";
import {store} from "../../Store/index.js";
import {JSessionUI} from "./Journey/JSessionUI.js";
import {observer_mgl} from "mobx-graphlink";

//export const journeyPanelHeights = [0, 50, 50, 0];

export const JourneyUI = observer_mgl(()=>{
	const uiState = store.main.engine.journey;
	return <JSessionUI/>;
});